const toRegex = (field) => {
  return searchText => {
    return searchText && {
      [`${field}.$regex`]: searchText,
      [`${field}.$options`]: 'i'
    }
  }
}
export default toRegex
